export * from './font-awesome-icon';
